var React = require('react');

function IconMail (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m6 6 21 18L48 6","stroke":"#fff","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M54.25.75H.75v34.5h53.5V.75Z","stroke":"#fff","strokeWidth":"1.5","key":1})]);
}

IconMail.defaultProps = {"width":"55","height":"36","viewBox":"0 0 55 36","fill":"none"};

module.exports = IconMail;

IconMail.default = IconMail;
